import { Accessor, createContext, useContext } from 'solid-js';

/*
	When rendering inside a preview pane in the backend preview, overlays should
	appear over the preview container, not the whole page.
	Works in tandem with frontend/Overlay.tsx
*/

const PreviewContext = createContext<Accessor<HTMLElement | undefined>>();

export function PreviewProvider(P:{children,value: Accessor<HTMLElement | undefined> | undefined})
{
	return (
		<PreviewContext.Provider value={P.value}>
			{P.children}
		</PreviewContext.Provider>
	);
}

export function usePreviewContainer(): Accessor<HTMLElement | undefined> | undefined 
{
	return useContext(PreviewContext);
}

export function isPreview()
{
	return usePreviewContainer() != null;
}
